import React from 'react';
import PropTypes from 'prop-types';

const EAPrefillModal = ({ productName, eaRequestNumber, skiRelease, onConfirm, onDismiss }) => (
  <div className="bc-draft-modal-overlay">
    <div className="bc-draft-modal">
      <h3 className="bc-draft-modal__title">EA Request Found</h3>
      <p className="bc-draft-modal__message">
        A GPR EA request (<strong>{eaRequestNumber}</strong>) already exists for{' '}
        <strong>{productName}</strong>
        {skiRelease ? ` (${skiRelease})` : ''}.
      </p>
      <p className="bc-draft-modal__message">
        Would you like to pre-fill the matching fields in this GA request from the EA request?
      </p>
      <div className="bc-draft-modal__actions">
        <button className="bc-draft-modal__btn bc-draft-modal__btn--primary" onClick={onConfirm}>
          Yes, pre-fill fields
        </button>
        <button className="bc-draft-modal__btn bc-draft-modal__btn--secondary" onClick={onDismiss}>
          No, start blank
        </button>
      </div>
    </div>
  </div>
);

EAPrefillModal.propTypes = {
  productName: PropTypes.string.isRequired,
  eaRequestNumber: PropTypes.string.isRequired,
  skiRelease: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired,
};

EAPrefillModal.defaultProps = {
  skiRelease: null,
};

export default EAPrefillModal;
